export class DownloadType {
  _id?: string;
  name: string = '';
  image: string = '';
  active: boolean = false;
  created: Date;
  updated: Date;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/download-types/shared/download-type.model.ts